module.exports = __webpack_public_path__ + "img/tbc-0-1.7fb32c98.webp";